import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/AnimatedBlock.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/AnimatedGrid.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/AnimatedLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/AnimatedText.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ParallaxImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/RotatingText.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
